import { DependencyList, useEffect, useRef } from 'react'

// useEffect that only runs when dependencies have updated. Does not run on mount of component
export function useUpdateEffect(callback: () => void, inputs: DependencyList): void {
  const didMountRef = useRef(false)

  useEffect(() => {
    if (didMountRef.current) {
      callback()
    } else {
      didMountRef.current = true
    }
    //eslint-disable-next-line
  }, inputs)
}
